export default __webpack_public_path__ + "static/media/finishing_line.d7f0a811.jpg";